module.exports = __webpack_public_path__ + "img/icon_info_small.9871ae9f.svg";